import WIDGETS from './widgets';

export default {
  name: 'food_questionnaire',
	widgets: [{ content: WIDGETS.DAILYREPORTFOODQUESTIONNAIRE, breakpoints: { xs: 12, sm: 12 } }],
};
